import { FunctionComponent, memo } from 'react';
import { SlotConsumer, SlotConsumerLazy } from '@media-platform/slot/src/react';
import { getSlot } from '../../utils/slots/slots';
import type * as T from './Slot.types';
import { useAppContext } from '../App/App.context';
const RBSlot: FunctionComponent<T.ISlotProps> = (props) => {
    const { layout, page_type } = useAppContext();
    const { alias, customParams, isLazy, isPageSpecificSlot, isMobile, ...componentProps } = props;
    const { custom } = layout;
    const slot = getSlot(alias, typeof isMobile !== 'undefined' ? isMobile : custom?.isMobile, customParams, isPageSpecificSlot ? page_type : undefined);
    if (typeof slot === 'undefined') {
        return null;
    }
    return isLazy ? (<SlotConsumerLazy slot={slot} {...componentProps}/>) : (<SlotConsumer slot={slot} {...componentProps}/>);
};
export default memo(RBSlot);
